import { isErrorRejected } from 'common/utils/ajax/apiErrorHandler'
import { MyAddress } from 'common/ducks/personalization/myAddress'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export const fetchMyBasicAddress = async (headers?: any): Promise<MyAddress> => {
  try {
    const response = await axios.get(`/v1/personalizeds/my-shipping-address`, {
      ...getHeaders(headers),
      data: {
        [isErrorRejected]: true,
      },
    })

    const { nid, baseAddress } = response && response.data

    return {
      ...(nid && { nid }),
      ...(baseAddress && { baseAddress }),
    }
  } catch (e) {
    return null
  }
}
